import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
//Material UI Imports
import {

  MenuItem,

} from '@mui/material';

const BankAccountTransaction = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [datacredit, setDatacredit] = useState([]);
  const [transactionoverview , setTransactionoverview] =useState({})
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");
  let para ={season_id:season_id};
  useEffect(() => {
        setPermission(FindModuleById(446)); 
        console.log(permission);



    axios.post("/bank-account-transactions/listing",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.expenses);
          setDatacredit(response.data.data.expenses_credit);
          setTransactionoverview(response.data.data.overview);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


const editItem = (item)=>{
  window.location.href = "/bank-account-transactions-edit/"+item;
}


  const deleteItem = (item) => {
      let season_id = localStorage.getItem("season_id");
     Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/bank-account-transactions/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/bank-account-transactions";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const columns =
 [


    {
      header: 'Bank',
      accessorFn: (row) => `${(row.bank_detail)?row.bank_detail.title:""} `,
    },
 
    {
      accessorKey: 'transaction_date', //normal accessorKey
      header: 'Transaction Date',
    }, 
    {
      header: 'Transaction Amount',
      accessorFn: (row) => `${(row.transaction_amount)?row.transaction_amount:""} MAD`,
    },
    {
      accessorKey: 'paid_to', //normal accessorKey
      header: 'Paid To',
    },
    {
      accessorKey: 'transaction_type', //normal accessorKey
      header: 'Transaction Type',
    },
    {
      header: 'Expense Type',
      accessorFn: (row) => `${(row.type)?row.type.title:""} `,
    },
  
    {
      accessorKey: 'note', //normal accessorKey
      header: 'Note',
    },
  
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
  ];




  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Bank Account Transaction</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Bank Account Transaction</li>
                </ul>
              </div>
              <div className="col-auto">
                
                {permission && permission.add == 1 && (
                  <Link to="/bank-account-transactions-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link>
                )}
              </div>
            </div>
          </div>
          <div className="row">
                
            
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                              <div className="card inovices-card w-100">
                                <div className="card-body">
                                  <div className="dash-widget-header">
                                    <div className="dash-count text-center">
                                      <div className="dash-title">BMCE EO</div>
                                      <div className="dash-counts">
                                        <p>{transactionoverview.bank_1}MAD</p>
                                      </div>
                                    </div>
                                  </div>
                                
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                              <div className="card inovices-card w-100">
                                <div className="card-body">
                                  <div className="dash-widget-header">
                                    <div className="dash-count text-center">
                                      <div className="dash-title">Credit Agricole EO</div>
                                      <div className="dash-counts">
                                        <p>{transactionoverview.bank_2}MAD</p>
                                      </div>
                                    </div>
                                  </div>
                                
                                </div>
                              </div>
                            </div>
                               
                            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                              <div className="card inovices-card w-100">
                                <div className="card-body">
                                  <div className="dash-widget-header">
                                    <div className="dash-count text-center">
                                      <div className="dash-title"> caixha Bank</div>
                                      <div className="dash-counts">
                                        <p>{transactionoverview.bank_4}MAD</p>
                                      </div>
                                    </div>
                                  </div>
                                
                                </div>
                              </div>
                            </div>
                               
                       
                      
                     
                            
                      </div>

                  <div className="row">
                  
                    <div className="col-sm-12">
                      <div className="card bg-white">
                  {permission && permission.list == 1 && ( 


                <div className="card-body">
                                      <ul className="nav nav-tabs nav-tabs-bottom">
                                      
                                    
                                      <li className="nav-item">
                                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">DEBIT</a>                                  
                                      </li>
                                      <li className="nav-item">
                                          <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> CREDIT</a>                                   
                                      </li>                    
                                      </ul>
                                      <div className="tab-content">
                                    
                                      <div className="tab-pane show active" id="listing-groupby-supplier">
                                      <div className="row"   id="listing-followup">
                                        <div className="col-sm-12">
                                          <div className="card card-table">
                                            <div className="card-body">
                                                <div className="table-responsive">

                                                <MaterialReactTable columns={columns} data={data} 
                                                                // enableColumnFilterModes
                                                                enableColumnOrdering
                                                                // enableGrouping
                                                                enablePinning
                                                                enableRowActions
                                                                // enableRowSelection
                                                                // initialState={{ showColumnFilters: true }}
                                                              
                                                              renderRowActionMenuItems={({ row }) => [
                                                                permission?.update == 1 && (
                                                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                                    Edit
                                                                  </MenuItem>
                                                                ),
                                                                permission?.delete == 1 && (
                                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                                    Delete
                                                                  </MenuItem>
                                                                ),
                                                              ]}
                                                              />
                                                </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                        
                                        </div>                                
                                        <div className="tab-pane  " id="listing-all">
                                          <div className="row"   id="listing-followup">
                                            <div className="col-sm-12">
                                              <div className="card card-table">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                    <MaterialReactTable columns={columns} data={datacredit} 
                                                                // enableColumnFilterModes
                                                                enableColumnOrdering
                                                                // enableGrouping
                                                                enablePinning
                                                                enableRowActions
                                                                // enableRowSelection
                                                                // initialState={{ showColumnFilters: true }}
                                                              
                                                                renderRowActionMenuItems={({ row }) => [
                                                                    permission?.update == 1 && (
                                                                      <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                                        Edit
                                                                      </MenuItem>
                                                                    ),
                                                                    permission?.delete == 1 && (
                                                                      <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                                        Delete
                                                                      </MenuItem>
                                                                    ),
                                                                  ]}
                                                              />
                                                    
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        
                                        </div>                                
                                      
                                      </div>                             
                                  </div>

                    )}
                      </div>
                  
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};
export default BankAccountTransaction;
